<template>
    <div>
        <hr />
        <div class="field-container">
            <h2 v-if="attack.type == 'multiple'">Primary Attack</h2>
            <div class="field quarter">
                <label for="" class="label">Attack Bonus Type</label>
                <div class="select">
                    <select name="" id="" :value="attack.primary.bonusSource" @change="updateAttackBonusSource">
                        <option value="weapon">Weapon</option>
                        <option value="implement">Implement</option>
                        <option value="statandbonus">Stat + Static Bonus</option>
                        <option value="static">Static Bonus</option>
                    </select>
                </div>
            </div>
            <div class="field quarter" v-if="attack.primary.bonusSource != 'static'">
                <label for="" class="label">Attack Stat</label>
                <div class="select">
                    <select name="" id="" :value="attack.primary.stat" @change="updateAttackStat">
                        <option value="Strength">Strength</option>
                        <option value="Dexterity">Dexterity</option>
                        <option value="Constitution">Constitution</option>
                        <option value="Intelligence">Intelligence</option>
                        <option value="Wisdom">Wisdom</option>
                        <option value="Charisma">Charisma</option>
                    </select>
                </div>
            </div>
            <div class="field quarter" v-if="isWeaponOrImplement">
                <label for="" class="label">Weapon/Implement #</label>
                <input type="text" class="input" :value="attack.primary.weaponNumber" @input="updateWeaponNumber">
            </div>
        </div>
        <div class="field-container">
            <div class="field quarter">
                <label for="" class="label">Defense</label>
                <div class="select">
                    <select name="" id="" :value="attack.primary.defense" @change="updateAttackDefense">
                        <option value="AC">AC</option>
                        <option value="Fort">Fort</option>
                        <option value="Ref">Ref</option>
                        <option value="Will">Will</option>
                    </select>
                </div>
            </div>
            <div class="field quarter">
                <label for="" class="label">Static Attack Bonus</label>
                <input type="text" class="input" :value="attack.primary.staticBonus" @input="updateAttackStaticBonus">
            </div>
            <div class="field quarter">
                <label for="" class="label">Crit on</label>
                <input type="number" class="input" :value="attack.primary.critRange" @input="updateCritRange">
            </div>
            <div class="field quarter" v-if="attack.type == 'area'">
                <label for="" class="label">Maximum Targets</label>
                <input type="text" class="input" :value="attack.maxTargets" @input="updateMaxTargets">
            </div>
        </div>
        <div class="field-container">
            <div class="field quarter">
                <label for="" class="checkbox">
                    <input type="checkbox" :checked="damage.primary.hasDamage" @change="updateHasDamage">
                    Has Damage?
                </label>
            </div>
            <div class="field quarter" v-if="damage.primary.hasDamage">
                <label for="" class="checkbox">
                    <input type="checkbox" :checked="damage.primary.addStatMod" @change="updateAddStatMod">
                    Add Stat Mod?
                </label>
            </div>
            <div class="field quarter" v-if="damage.primary.hasDamage">
                <label for="" class="checkbox">
                    <input type="checkbox" :checked="damage.primary.isBrutal" @change="updateIsBrutal">
                    Reroll Less than X (Brutal)?
                </label>
            </div>
        </div>
        <div class="field-container" v-if="damage.primary.hasDamage">
            <div class="field quarter">
                <label for="" class="label">Dice/[W] Quantity</label>
                <input type="text" class="input" :value="damage.primary.diceQuantity" @input="updateDiceQuantity">
            </div>
            <div class="field quarter" v-if="attack.primary.bonusSource != 'weapon'">
                <label for="" class="label">Dice Sides</label>
                <input type="text" class="input" :value="damage.primary.diceSides" @input="updateDiceSides">
            </div>
            <div class="field quarter">
                <label for="" class="label">Static Damage Bonus</label>
                <input type="text" class="input" :value="damage.primary.staticBonus" @input="updateDamageStaticBonus">
            </div>
            <div class="field quarter">
                <label for="" class="label">Damage Type</label>
                <input type="text" class="input" :value="damage.primary.type" @input="updateDamageType">
            </div>
            <div class="field quarter" v-if="damage.primary.isBrutal">
                <label for="" class="label">Brutal Value</label>
                <input type="text" class="input" :value="damage.primary.brutalValue" @input="updateBrutalValue">
            </div>
        </div>
        <div class="field-container">
            <div class="field">
                <label for="" class="label">Hit Effect</label>
                <textarea name="" id="" cols="30" rows="3" class="textarea" :value="attack.primary.hitEffect" @input="updateHitEffect"></textarea>
            </div>
            <div class="field">
                <label for="" class="label">Miss Effect</label>
                <textarea name="" id="" cols="30" rows="3" class="textarea" :value="attack.missEffect" @input="updateMissEffect"></textarea>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    data: function() {
        return {

        };
    },
    computed: {
        ...mapState({
            attack: state => state.attack,
            damage: state => state.damage,
        }),
        isWeaponOrImplement() {
            return this.attack.primary.bonusSource == 'weapon' || this.attack.primary.bonusSource == 'implement';
        },
    },
    methods: {
        updateAttackStat(e) {
            this.$store.commit('attack/setStat', e.target.value);
        },
        updateAttackBonusSource(e) {
            this.$store.commit('attack/setBonusSource', e.target.value);
        },
        updateWeaponNumber(e) {
            this.$store.commit('attack/setWeaponNumber', e.target.value);
        },
        updateAttackDefense(e) {
            this.$store.commit('attack/setDefense', e.target.value);
        },
        updateAttackStaticBonus(e) {
            this.$store.commit('attack/setStaticBonus', e.target.value);
        },
        updateCritRange(e) {
            this.$store.commit('attack/setCritRange', e.target.value);
        },
        updateHasDamage(e) {
            this.$store.commit('damage/setHasDamage', e.target.checked);
        },
        updateDiceQuantity(e) {
            this.$store.commit('damage/setDiceQuantity', e.target.value);
        },
        updateDiceSides(e) {
            this.$store.commit('damage/setDiceSides', e.target.value);
        },
        updateDamageStaticBonus(e) {
            this.$store.commit('damage/setStaticBonus', e.target.value);
        },
        updateAddStatMod(e) {
            this.$store.commit('damage/setAddStatMod', e.target.checked);
        },
        updateDamageType(e) {
            this.$store.commit('damage/setType', e.target.value);
        },
        updateHitEffect(e) {
            this.$store.commit('attack/setHitEffect', e.target.value);
        },
        updateMissEffect(e) {
            this.$store.commit('attack/setMissEffect', e.target.value);
        },
        updateMaxTargets(e) {
            this.$store.commit('attack/setMaxTargets', e.target.value);
        },
        updateIsBrutal(e) {
            this.$store.commit('damage/setIsBrutal', e.target.checked);
        },
        updateBrutalValue(e) {
            this.$store.commit('damage/setBrutalValue', e.target.value);
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
